import { LocalStorageKey } from 'constants/enums'
import { ComponentBase } from 'utils/abstract-classes/component-base'
import { attachEventHandlerWithFemFlagCheck } from 'utils/events'

export class MemberContentComponent extends ComponentBase {
    private memberType: string
    private memberOnly: boolean
    private userStatus: string

    /**
     * The member content component will show/hide partial content from HTML
     * @param memberContent membership content element
     */
    public constructor(protected el: HTMLElement) {
        super()
        this.memberType = el.dataset.memberType || ''
        this.memberOnly = el.dataset.memberOnly === 'true'
        if (!this.memberType) {
            return
        }

        attachEventHandlerWithFemFlagCheck('pnIdReady', () => {
            void this.handleMemberContent()
        })
    }

    /**
     * handle content by user status
     */
    public handleMemberContent(): void {
        this.userStatus = this.getUserType()
        this.handleContent()
    }

    /**
     * get user type from localStorage
     * @returns string
     */
    private getUserType(): string {
        const isLoggedIn =
            localStorage.getItem(LocalStorageKey.LRTOKENKEY) || ''
        const userData = JSON.parse(
            localStorage.getItem(LocalStorageKey.XID) || '{}'
        ).data

        if (!isLoggedIn) {
            return 'anonymous'
        } else if (isLoggedIn && userData && userData.adLight) {
            return 'subscriber'
        }
        return 'register'
    }

    /**
     * Anonymous user will not see register or subscriber content element
     * Register user will not see subscriber and anonymous only content element
     * Subscriber user will not see anonymous only and register only content element
     */
    private handleContent(): void {
        if (
            this.isMemberOnlyConent() ||
            this.isAnonymousBlockContent() ||
            this.isRegisterBlockContent()
        ) {
            this.el.remove()
        } else {
            this.el.classList.remove('hidden')
        }
    }

    /**
     * Check member only content
     * @returns boolean
     */
    private isMemberOnlyConent(): boolean {
        return this.memberOnly === true && this.memberType !== this.userStatus
    }

    /**
     * Check member content which is not allowed anonymous user
     * The register & subscriber content element will be removed for anonymous user
     * @returns boolean
     */
    private isAnonymousBlockContent(): boolean {
        return (
            this.userStatus === 'anonymous' &&
            ['subscriber', 'register'].includes(this.memberType)
        )
    }

    /**
     * Check member content which is not allowed register user
     * The subscriber content element will be removed for register user
     * @returns boolean
     */
    private isRegisterBlockContent(): boolean {
        return (
            this.userStatus === 'register' && this.memberType === 'subscriber'
        )
    }
}
